import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth, GoogleAuthProvider, FacebookAuthProvider } from 'firebase/auth';

// Firebase project used for Google/Facebook sign-in on the web client. This
// deployment needs its own Firebase project — set these via REACT_APP_* env
// vars at build time (see .env.example).
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
};

// getAuth() throws synchronously (auth/invalid-api-key) when the config is
// blank, and this module is imported by SignUp/Login at the top level —
// confirmed by actually deploying this: it crashed the *entire* app at
// render time (blank white screen, nothing mounted), not just the
// Google/Facebook sign-in buttons as the comment here used to assume.
// auth/providerOAuth/providerFC are only ever used inside click handlers
// (signInWithPopup), never at module load, so a null auth here is safe —
// it just makes those specific buttons fail when clicked, unconfigured.
let auth: Auth | null = null;
try {
    if (!firebaseConfig.apiKey) {
        throw new Error('REACT_APP_FIREBASE_API_KEY not set');
    }
    const app: FirebaseApp = initializeApp(firebaseConfig);
    auth = getAuth(app);
} catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Firebase not configured — Google/Facebook web sign-in disabled:', e);
}

const providerOAuth = new GoogleAuthProvider();

providerOAuth.setCustomParameters({
    prompt: 'select_account',
});

const providerFC = new FacebookAuthProvider();

providerFC.setCustomParameters({
    prompt: 'select_account',
});

export { auth, providerOAuth, providerFC };
